/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  FulfillmentCreateBrandBillingCategoryEnum2,
  FulfillmentCreateBrandData,
  FulfillmentCreateBrandPalletCarrierEnum2,
  FulfillmentCreateBrandParcelCarrierEnum2,
  FulfillmentCreateOrderData,
  FulfillmentCreateOrderDetailEnum,
  FulfillmentCreateOrderParams,
  FulfillmentCreateOrderRecipientTypeEnum2,
  FulfillmentCreateOrderRecipientTypeEnum3,
  FulfillmentCreateOrderServicesEnum,
  FulfillmentCreateOrderServicesEnum1,
  FulfillmentCreateOrderTypeEnum,
  FulfillmentGetBrandData,
  FulfillmentGetWarehouseData,
  FulfillmentListWarehousesData,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Fulfillment<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
 * @description Creates a new fulfillment order
 *
 * @tags AnkorstoreInternal_Fulfillment
 * @name FulfillmentCreateOrder
 * @summary Create Fulfillment Order
 * @request POST:/api/internal/v1/fulfillment/orders
 * @response `200` `FulfillmentCreateOrderData` This status is sent when validation is requested and succeeded
 * @response `201` `{
    data: {
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type: string,
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
    attributes: {
  \**
   * Unique human readable reference for the fulfillment order, used for communication with the warehouse
   * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
   *\
    reference?: string,
  \** @format uuid *\
    masterOrderUuid: string,
  \** @format uuid *\
    fulfillmentBrandId?: string,
  \**
   * [Deprecated] This concept no longer exists. Please refer to the related master order if you need to distinguish between internal and external orders
   * @deprecated
   *\
    isDirect?: boolean,
  \** Is shipping fee charged for order, default to true *\
    shippingCharged?: boolean,
    status?: FulfillmentCreateOrderStatusEnum2,
  \** @format date-time *\
    createdAt?: string,
  \** Shipping address for the recipient. Required for order creation *\
    shippingAddress?: (({
  \** @minLength 1 *\
    firstName?: string,
  \** @minLength 1 *\
    lastName?: string,
    company?: string,
  \** @minLength 1 *\
    phone?: string,
    email?: string,
  \** @minLength 1 *\
    street?: string,
  \** @minLength 1 *\
    city?: string,
    postalCode?: string,
  \** @pattern ^[A-Z]{2}$ *\
    country?: string,

}) | null),
  \** Optional billing address for the recipient *\
    billingAddress?: ({
  \** @minLength 1 *\
    firstName?: string,
  \** @minLength 1 *\
    lastName?: string,
    company?: string,
  \** @minLength 1 *\
    phone?: string,
    email?: string,
  \** @minLength 1 *\
    street?: string,
  \** @minLength 1 *\
    city?: string,
    postalCode?: string,
  \** @pattern ^[A-Z]{2}$ *\
    country?: string,

} | null),
    items: ({
  \** @format uuid *\
    fulfillmentItemId: string,
  \** quantity in batches *\
    quantity: number,

})[],
  \**
   * The type of recipient for a fulfillment order
   * @default "business"
   *\
    recipientType?: FulfillmentCreateOrderRecipientTypeEnum1,

},
    links?: {
    order?: string,

},
    relationships?: {
    statusUpdates?: {
  \**
   * An array of objects each containing `type` and `id` members for to-many relationships.
   * @uniqueItems true
   *\
    data?: ({
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],

},
    shipments?: {
  \**
   * An array of objects each containing `type` and `id` members for to-many relationships.
   * @uniqueItems true
   *\
    data?: ({
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

})[],

},

},

},
  \** An object describing the server's implementation *\
    jsonapi: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},
    included?: (({
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type?: string,
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id?: string,
  \** Shipment tracking info. Will be null until this information is available *\
    attributes?: {
    trackingNumber?: string,
    trackingLink?: string | null,
  \** Shipping provider identifier *\
    provider?: string,
  \** Shipping provider display name *\
    providerName?: string,
  \** Parcel or pallet width (in MM) *\
    width?: number,
  \** Parcel or pallet length (in MM) *\
    length?: number,
  \** Parcel or pallet height (in MM) *\
    height?: number,
  \** Parcel or pallet weight (in GR) *\
    weight?: number,
  \** @format date-time *\
    createdAt?: string,

},

} | {
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type?: string,
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id?: string,
  \** Fulfillment order status update *\
    attributes?: {
    status?: FulfillmentCreateOrderStatusEnum3,
  \** @format date-time *\
    receivedAt?: string,

},

}))[],

}` This status is sent when order is successfuly created
 * @response `400` `{
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},
    errors?: ({
    detail?: FulfillmentCreateOrderDetailEnum,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** General description of the problem *\
    title?: string,
    meta?: {
    undeclaredItems?: (string)[],
    unavailableItems?: (string)[],
    [key: string]: any,

},

})[],

}` Fulfillment order creation error response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  fulfillmentCreateOrder = (
    query: FulfillmentCreateOrderParams,
    data:
      | {
          data: {
            type: FulfillmentCreateOrderTypeEnum;
            /**
             * Optional client-specified fulfillment order ID. When provided, the server uses this UUID as the order identifier. If a FulfillmentOrder with this UUID already exists, the existing order is returned with a 200 status (idempotent).
             * @format uuid
             */
            id?: string;
            attributes: {
              reference?: string;
              /** Ankorstore order ID, or null for direct fulfillment order */
              orderId?: number | null;
              /**
               * Ankorstore master order uuid
               * @format uuid
               */
              masterOrderUuid: string;
              /** @format uuid */
              fulfillmentBrandId?: string;
              /** Is shipping fee charged for order, default to true */
              shippingCharged?: boolean;
              /** Shipping address for the recipient. Required for order creation */
              shippingAddress: {
                /** @minLength 1 */
                firstName?: string;
                /** @minLength 1 */
                lastName?: string;
                company?: string;
                /** @minLength 1 */
                phone?: string;
                email?: string;
                /** @minLength 1 */
                street?: string;
                /** @minLength 1 */
                city?: string;
                postalCode?: string;
                /** @pattern ^[A-Z]{2}$ */
                country?: string;
              };
              /** Optional billing address for the recipient */
              billingAddress?: {
                /** @minLength 1 */
                firstName?: string;
                /** @minLength 1 */
                lastName?: string;
                company?: string;
                /** @minLength 1 */
                phone?: string;
                email?: string;
                /** @minLength 1 */
                street?: string;
                /** @minLength 1 */
                city?: string;
                postalCode?: string;
                /** @pattern ^[A-Z]{2}$ */
                country?: string;
              } | null;
              items: (
                | {
                    /** @format uuid */
                    fulfillableId: string;
                    /** quantity in batches */
                    batchQuantity: number;
                  }
                | {
                    /** @format uuid */
                    fulfillableId: string;
                    /** quantity in units */
                    unitQuantity: number;
                  }
                | {
                    /** @format uuid */
                    fulfillableId: string;
                    /** quantity in batches */
                    quantity: number;
                  }
                | {
                    /** @format uuid */
                    productVariantUuid: string;
                    /** quantity in batches */
                    batchQuantity: number;
                  }
                | {
                    /** @format uuid */
                    productVariantUuid: string;
                    /** quantity in units */
                    unitQuantity: number;
                  }
              )[];
              externalReference?: string | null;
              /**
               * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
               * @deprecated
               */
              instructionText?: string | null;
              instructions?: {
                externalReference?: string | null;
                /**
                 * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
                 * @default false
                 */
                pickupAtDock?: boolean;
                deliverySchedule?: {
                  /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
                  timeSlots:
                    | {
                        /**
                         * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                         * @example "09:30"
                         */
                        startTime: string;
                        /**
                         * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                         * @example "12:30"
                         */
                        endTime: string;
                      }[]
                    | null;
                  /**
                   * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
                   * @minItems 1
                   * @uniqueItems true
                   * @example [1,2,3]
                   */
                  openDays: number[];
                } | null;
                packingInstruction?: {
                  /**
                   * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
                   * @minItems 1
                   */
                  services: FulfillmentCreateOrderServicesEnum[];
                  /** Instruction text for packing the order. */
                  instruction?: string;
                } | null;
                deliveryAppointment?: {
                  /** Is an appointment requested? */
                  requested: boolean;
                  /** Instruction text for booking an appointment. */
                  instruction: string;
                } | null;
              } | null;
              /**
               * The type of recipient for a fulfillment order
               * @default "business"
               */
              recipientType?: FulfillmentCreateOrderRecipientTypeEnum2;
            };
          };
        }
      | {
          reference?: string;
          /** Ankorstore order ID, or null for direct fulfillment order */
          orderId?: number | null;
          /**
           * Ankorstore master order uuid
           * @format uuid
           */
          masterOrderUuid: string;
          /** @format uuid */
          fulfillmentBrandId?: string;
          /** Is shipping fee charged for order, default to true */
          shippingCharged?: boolean;
          /** Shipping address for the recipient. Required for order creation */
          shippingAddress: {
            /** @minLength 1 */
            firstName?: string;
            /** @minLength 1 */
            lastName?: string;
            company?: string;
            /** @minLength 1 */
            phone?: string;
            email?: string;
            /** @minLength 1 */
            street?: string;
            /** @minLength 1 */
            city?: string;
            postalCode?: string;
            /** @pattern ^[A-Z]{2}$ */
            country?: string;
          };
          /** Optional billing address for the recipient */
          billingAddress?: {
            /** @minLength 1 */
            firstName?: string;
            /** @minLength 1 */
            lastName?: string;
            company?: string;
            /** @minLength 1 */
            phone?: string;
            email?: string;
            /** @minLength 1 */
            street?: string;
            /** @minLength 1 */
            city?: string;
            postalCode?: string;
            /** @pattern ^[A-Z]{2}$ */
            country?: string;
          } | null;
          items: (
            | {
                /** @format uuid */
                fulfillableId: string;
                /** quantity in batches */
                batchQuantity: number;
              }
            | {
                /** @format uuid */
                fulfillableId: string;
                /** quantity in units */
                unitQuantity: number;
              }
            | {
                /** @format uuid */
                fulfillableId: string;
                /** quantity in batches */
                quantity: number;
              }
            | {
                /** @format uuid */
                productVariantUuid: string;
                /** quantity in batches */
                batchQuantity: number;
              }
            | {
                /** @format uuid */
                productVariantUuid: string;
                /** quantity in units */
                unitQuantity: number;
              }
          )[];
          externalReference?: string | null;
          /**
           * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
           * @deprecated
           */
          instructionText?: string | null;
          instructions?: {
            externalReference?: string | null;
            /**
             * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
             * @default false
             */
            pickupAtDock?: boolean;
            deliverySchedule?: {
              /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
              timeSlots:
                | {
                    /**
                     * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "09:30"
                     */
                    startTime: string;
                    /**
                     * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "12:30"
                     */
                    endTime: string;
                  }[]
                | null;
              /**
               * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
               * @minItems 1
               * @uniqueItems true
               * @example [1,2,3]
               */
              openDays: number[];
            } | null;
            packingInstruction?: {
              /**
               * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
               * @minItems 1
               */
              services: FulfillmentCreateOrderServicesEnum1[];
              /** Instruction text for packing the order. */
              instruction?: string;
            } | null;
            deliveryAppointment?: {
              /** Is an appointment requested? */
              requested: boolean;
              /** Instruction text for booking an appointment. */
              instruction: string;
            } | null;
          } | null;
          /**
           * The type of recipient for a fulfillment order
           * @default "business"
           */
          recipientType?: FulfillmentCreateOrderRecipientTypeEnum3;
        },
    params: RequestParams = {}
  ) =>
    this.request<
      FulfillmentCreateOrderData,
      | {
          /** An object describing the server's implementation */
          jsonapi?: {
            /** @example "1.0" */
            version?: string;
            /** Non-standard meta-information that can not be represented as an attribute or relationship. */
            meta?: Record<string, any>;
          };
          errors?: {
            detail?: FulfillmentCreateOrderDetailEnum;
            /** The HTTP status code applicable to this problem, expressed as a string value. */
            status?: string;
            /** General description of the problem */
            title?: string;
            meta?: {
              undeclaredItems?: string[];
              unavailableItems?: string[];
              [key: string]: any;
            };
          }[];
        }
      | {
          /** @uniqueItems true */
          errors: {
            /** An application-specific error code, expressed as a string value. */
            code?: string;
            /** A human-readable explanation specific to this occurrence of the problem. */
            detail?: string;
            /** The HTTP status code applicable to this problem, expressed as a string value. */
            status?: string;
            /** The HTTP status code description applicable to this problem */
            title?: string;
            /** Optional object pointing towards the problematic field */
            source?: {
              /** The field key */
              pointer?: string;
            };
          }[];
          /** An object describing the server's implementation */
          jsonapi?: {
            /** @example "1.0" */
            version?: string;
            /** Non-standard meta-information that can not be represented as an attribute or relationship. */
            meta?: Record<string, any>;
          };
        }
    >({
      path: `/api/internal/v1/fulfillment/orders`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Returns a list of warehouses available to provide fulfillment services
 *
 * @tags AnkorstoreInternal_Fulfillment
 * @name FulfillmentListWarehouses
 * @summary List of warehouses available to handle fulfillment
 * @request GET:/api/internal/v1/fulfillment/warehouses
 * @response `200` `FulfillmentListWarehousesData` Set of warehouses
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  fulfillmentListWarehouses = (params: RequestParams = {}) =>
    this.request<
      FulfillmentListWarehousesData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/fulfillment/warehouses`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Returns details of a warehouse
 *
 * @tags AnkorstoreInternal_Fulfillment
 * @name FulfillmentGetWarehouse
 * @summary Details of a single warehouse
 * @request GET:/api/internal/v1/fulfillment/warehouses/{id}
 * @response `200` `FulfillmentGetWarehouseData` Single warehouse
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  fulfillmentGetWarehouse = (id: string, params: RequestParams = {}) =>
    this.request<
      FulfillmentGetWarehouseData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/fulfillment/warehouses/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Returns a fulfillment brand
 *
 * @tags AnkorstoreInternal_Fulfillment
 * @name FulfillmentGetBrand
 * @summary Details of a single Fulfillment brand
 * @request GET:/api/internal/v1/fulfillment/fulfillment-brands/{id}
 * @response `200` `FulfillmentGetBrandData` Single fulfillment brand
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  fulfillmentGetBrand = (id: string, params: RequestParams = {}) =>
    this.request<
      FulfillmentGetBrandData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/fulfillment/fulfillment-brands/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Creates a new fulfillment brand
 *
 * @tags AnkorstoreInternal_Fulfillment
 * @name FulfillmentCreateBrand
 * @summary Create Fulfillment Brand
 * @request POST:/api/internal/v1/fulfillment/fulfillment-brands
 * @response `200` `FulfillmentCreateBrandData` Single fulfillment brand
 * @response `201` `{
    data: {
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type: string,
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
    attributes: {
  \** @format uuid *\
    warehouseId: string,
    billingCategory: FulfillmentCreateBrandBillingCategoryEnum1,
    reference: string,
    parcelCarrier?: FulfillmentCreateBrandParcelCarrierEnum1,
    palletCarrier?: FulfillmentCreateBrandPalletCarrierEnum1,
    maxParcelShipmentWeight?: number | null,

},
    relationships?: {
    warehouse?: {
  \** Resource identification present in Resource Objects and Resource Identifier Objects. *\
    data?: {
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

},

},

},
  \** An object describing the server's implementation *\
    jsonapi: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},
    included?: (({
  \** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) *\
    type: string,
  \**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   *\
    id: string,
  \** FulfillmentItem *\
    attributes: {
    code: string,
    name: string,
    "addresseLine1"?: string,
    "addresseLine2"?: string,
    postalCode: string,
    city: string,
  \** @pattern ^[A-Z]{2}$ *\
    countryCode: string,
    email: string,
    phone: string,
  \** @format uuid *\
    astralLocationId: string | null,

},

}))[],

}` Single fulfillment brand
 * @response `400` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Bad request
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  fulfillmentCreateBrand = (
    data: {
      /** Ankorstore brand ID */
      brandId: number;
      brandName: string;
      /** @format uuid */
      warehouseId?: string;
      billingCategory?: FulfillmentCreateBrandBillingCategoryEnum2;
      parcelCarrier?: FulfillmentCreateBrandParcelCarrierEnum2;
      palletCarrier?: FulfillmentCreateBrandPalletCarrierEnum2;
      maxParcelShipmentWeight?: number | null;
    },
    params: RequestParams = {}
  ) =>
    this.request<
      FulfillmentCreateBrandData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/fulfillment/fulfillment-brands`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
